<template>
    <show-admins ref="registerAdmin" v-bind:is-me="false" v-bind:is-deps="false" v-bind:title="'Εμφάνιση Διαχειριστών ΓΕΣ/Α4 (ΔΕΠΕΘ)'" />
</template>

<script>
import ShowAdmins from "../components/ShowAdmins";

export default {
    name: "ShowAdminsDes",
    components: {
        ShowAdmins
    },
}
</script>
